var config = require(/*! ../config */"../config.js");
var utils = require(/*! ./utils */"./utils.js");
var ahk = require(/*! ../../antihackkey.json */"../../antihackkey.json");
module.exports = {
  ahNum: 0,
  socket: null,
  connected: false,
  socketId: -1,
  sendQueue: [],
  connect: function (address, callback, events) {
    if (this.socket) {
      return;
    }

    // CREATE SOCKET:
    var protocol = config.enableHttps ? "wss:" : "ws:";
    var _this = this;
    try {
      var socketError = false;
      var socketAddress = protocol + address;
      this.socket = new WebSocket(socketAddress);
      this.socket.binaryType = "arraybuffer";
      this.socket.onmessage = function (message) {
        // PARSE MESSAGE:
        var parsed = utils.decodeNetworkMessage(message.data)[0];
        var type = parsed[0];
        var data = parsed[1];

        // CALL EVENT:
        if (type == "io-init") {
          _this.socketId = data[0];
        } else {
          if (events[type]) {
            events[type].apply(undefined, data);
          } else {
            console.error("Received unregistered event", type);
          }
        }
      };
      this.socket.onopen = function () {
        // OPEN:
        _this.connected = true;
        callback();

        // SEND QUEUED MESSAGES:
        for (let message of _this.sendQueue) {
          _this.send(message[0], ...message[1]);
        }
      };
      this.socket.onclose = function () {
        _this.connected = false;
        if (!socketError) {
          callback("Disconnected. Try connecting to another server.");
        }
      };
      this.socket.onerror = function (error) {
        if (this.socket.readyState != WebSocket.OPEN) {
          socketError = true;
          console.error("Socket error", arguments);
          callback("Socket error");
        }
      };
    } catch (e) {
      console.error("Socket connection error:", e);
      callback(e);
    }
  },
  send: function (type, ...data) {
    // QUEUE MESSAGE:
    if (!this.socket || this.socket.readyState !== WebSocket.OPEN) {
      console.warn("Socket not open yet", type, data);
      this.sendQueue.push([type, data]);
      return;
    }

    // UPDATE ANTIHACK NUMBER:
    this.ahNum = utils.rotateNumber(this.ahNum, ahk);

    // SEND MESSAGE:
    var binary = utils.encodeNetworkMessage([type, data], this.ahNum);
    this.socket.send(binary);
  },
  socketReady: function () {
    return this.socket && this.connected;
  }
};